import React, { Component } from 'react';
import Modal from 'react-modal';
import Youtube from 'react-youtube';
import LazyLoad from 'react-lazyload';

const customStyles = {
	overlay: {
		backgroundColor: 'rgba(0,0,0,0.75)',
		zIndex: 999
	},
	content: {
		top: '50%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		marginRight: '-50%',
		borderRadius: '4px',
		border: 'none',
		background: 'transparent',
		transform: 'translate(-50%, -50%)',
		overflow: 'hidden',
		width: '100%',
		maxWidth: 960
	}
};

class Video extends Component {
	constructor(props) {
		super(props);
		this.state = {
			modalOpen: false
		};
	}

	openModal() {
		this.setState({ modalOpen: true });
		const dataLayer = global.dataLayer;
		dataLayer.push({
			event: 'Support Video',
			eventCategory: 'Support',
			eventAction: 'Video Play',
			eventLabel: this.props.video.title
		});
	}

	closeModal() {
		this.setState({ modalOpen: false });
	}

	render() {
		const { title, category, youtubeId } = this.props.video;
		const thumbSrc = `//img.youtube.com/vi/${youtubeId}/mqdefault.jpg`;
		const opts = {
			playerVars: {
				autoplay: 1,
				rel: 0
			}
		};

		const modal = (
			<Modal
				isOpen={ this.state.modalOpen }
				onRequestClose={ () => this.closeModal() }
				style={ customStyles }
				contentLabel="Modal"
			>
				<button className="ReactModal__close" onClick={ () => this.closeModal() }>
					<span className="fa fa-times" aria-hidden="true" />
					<span className="assistive-text">close</span>
				</button>
				<div className="embed-responsive-16x9">
					<Youtube videoId={ youtubeId } opts={ opts } />
				</div>
			</Modal>
		);

		return (
			<li>
				<div className="video-card">
					<div className="embed-responsive-16x9" onClick={ () => this.openModal() }>
						<LazyLoad once={ true } offset={ 200 }>
							<img src={ thumbSrc } alt={ title } role="presentation" />
						</LazyLoad>
						<span className="fa fa-play" aria-hidden="true" />
					</div>
					<div className="video-details">
						<span className="video-category">{ category }</span>
						<h2 className="video-title">{ title }</h2>
					</div>
					{ modal }
				</div>
			</li>
		);
	}
}

export default Video;


// WEBPACK FOOTER //
// ./src/pages/support/videos/Video.js